export default {
    CASO_NOVO: 1,
    CONTINUIDADE: 2,
    RENOVACAO: 3,
    TROCA_INCLUSAO: 4,
}